import { Link } from 'react-router-dom';
import type { Movie, CategoryType } from '@/types/movie';
import { CATEGORY_LABELS } from '@/types/movie';
import MovieCard from '@/components/base/MovieCard';

interface FeaturedSectionProps {
  category: CategoryType;
  title: string;
  subtitle: string;
  items: Movie[];
}

export default function FeaturedSection({ category, title, subtitle, items }: FeaturedSectionProps) {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="flex items-end justify-between mb-6 border-b border-background-200 pb-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-1 h-6 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-xl md:text-2xl font-extrabold text-foreground-950">{title}</h2>
          </div>
          <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p>
        </div>
        <Link
          to={`/category/${category}`}
          className="hidden sm:inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
        >
          查看全部{CATEGORY_LABELS[category]}
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
        {items.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}